import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const ticketTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default ticketTypeConfig;
